import { PlayArrowRounded } from '@mui/icons-material'
import { Button, Chip, Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { MaterialReactTable, MRT_ColumnDef, MRT_TableOptions } from 'material-react-table'
import { FunctionComponent, useState } from 'react'

import AlertLoading from '../../../../base/components/Alert/AlertLoading'
import StackMenu from '../../../../base/components/MyMenu/StackMenu'
import { StackMenuItem } from '../../../../base/components/MyMenu/StackMenuItem'
import SimpleCard from '../../../../base/components/Template/Cards/SimpleCard'
import { KardexPeriodoProps } from '../../../../base/interfaces'
import {
  MuiDisplayColumnDefOptions,
  MuiTableBasicOptionsProps,
  MuiTableProps,
} from '../../../../utils/muiTable/materialReactTableUtils'
import { apiKardexPeriodoActivo } from '../../api/apiKardexPeriodoActivo'
import KardexPeriodoIniciar from '../iniciar/KardexPeriodoIniciar'

interface OwnProps {}

type Props = OwnProps
//definimos las columnas
const tableColumns: MRT_ColumnDef<KardexPeriodoProps>[] = [
  { header: 'Código', accessorKey: 'codigo', size: 100 },
  { header: 'Periodo', accessorKey: 'descripcion', size: 200 },
  {
    accessorFn: (row) => <Chip size={'small'} label={row.state} color={'success'} />,
    id: 'state',
    header: 'Estado',
    size: 100,
  },
]

/**
 * Mostramos el Kardex Period activo
 * @param props
 * @constructor
 */
const KardexPeriodoListado: FunctionComponent<Props> = (props) => {
  const [openIniciarKardexPeriodo, setOpenIniciarKardexPeriodo] = useState<boolean>(false)

  const {
    data: kardexPeriodo,
    isLoading: kardexPeriodoLoading,
    refetch,
  } = useQuery({
    queryKey: ['kardexPeriodoListado'],
    queryFn: () => {
      return apiKardexPeriodoActivo()
    },
    refetchOnWindowFocus: true,
    refetchInterval: false,
  })

  if (kardexPeriodoLoading)
    return (
      <>
        <AlertLoading mensaje={'Cargando Kardex Periodo Activo...'} />
      </>
    )

  return (
    <SimpleCard title={'Periodo Activo'}>
      <StackMenu asideSidebarFixed>
        {!kardexPeriodo && (
          <StackMenuItem>
            <Button
              variant="contained"
              size={'small'}
              onClick={() => setOpenIniciarKardexPeriodo(true)}
              startIcon={<PlayArrowRounded />}
              color={'primary'}
            >
              Iniciar Periodo
            </Button>
          </StackMenuItem>
        )}
      </StackMenu>

      <Grid container>
        <Grid size={12}>
          <MaterialReactTable
            {...(MuiTableBasicOptionsProps as MRT_TableOptions<KardexPeriodoProps>)}
            columns={tableColumns}
            data={kardexPeriodo ? [kardexPeriodo] : []}
            initialState={{
              density: 'compact',
            }}
            displayColumnDefOptions={MuiDisplayColumnDefOptions}
            muiTableProps={MuiTableProps}
            enableTopToolbar={false}
            muiTableBodyRowProps={{ hover: false }}
            enableTableHead
          />
        </Grid>
      </Grid>
      <KardexPeriodoIniciar
        id="IniciarKardexPeriodo"
        open={openIniciarKardexPeriodo}
        keepMounted={false}
        onClose={(value?: KardexPeriodoProps) => {
          if (value) {
            refetch().then()
          }
          setOpenIniciarKardexPeriodo(false)
        }}
      />
    </SimpleCard>
  )
}
export default KardexPeriodoListado
